import {authStore} from '@/composables/store-accessor'
export default defineNuxtRouteMiddleware(() => {
    const {origin} = useRequestURL()
    const $conf = useNuxtApp().$conf
    const companyType = authStore.companyType
    const role = authStore.person?.role

    if ($conf.public.routerBase && process.env.NODE_ENV !== 'development' && !$conf.public.showHome) {
        return navigateTo(origin, {external: true})
    }
    if (companyType === 'INTERNAL_SUPPLIER') {
        return navigateTo('/supplier')
    }
    if (role === 'to1l.guide' || role === 'to1l.driver' || role === 'to1l.dispatcher') {
        return navigateTo('/scheduler')
    }
    if (role) {
        return navigateTo({name: 'orders'})
    }
})
